<template>
    <!-- top-24 for top nav -->
    <div
        :class="['flex-col flex-1 lg:absolute lg:top-24 lg:right-0 bottom-0 lg:!flex overflow-y-auto lg:w-[600px]',
                 showOnMobile ? '' : 'hidden',
                 isDesktop.value ? '' : 'app-height'
        ]">
        <slot />
    </div>
</template>

<script>
    import { useMediaQuery } from '@vueuse/core';
    import { DESKTOP_BREAKPOINT } from '../../constants';

    export default {
        name: 'FullScreenPanel',
        props: {
            showOnMobile: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            isDesktop() {
                return useMediaQuery(`(min-width: ${DESKTOP_BREAKPOINT}px)`);
            },
        },
    };
</script>

<style>
    @import "../../style/variables.scss";

    .app-height {
        min-height: var(--app-height);
        height: var(--app-height);
    }
</style>